var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-body"},[_c('div',{staticClass:"l-menu",on:{"click":_vm.handleClick}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }